<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App",
  computed: {},
  data() {
    return {};
  },
};
</script>

<style>
</style>
